const TOKEN_KEY = 'mindforge_session';

export function getAuthToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setAuthToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearAuthToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export async function authFetch(url, options = {}) {
  const token = getAuthToken();
  const headers = { ...options.headers };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const { credentials, ...rest } = options;
  const response = await fetch(url, { ...rest, headers });

  if (response.status === 401) {
    const hadToken = !!getAuthToken();
    clearAuthToken();
    if (hadToken && window.location.pathname !== '/') {
      import('sonner').then(({ toast }) => toast.error('Session expired, please log in again'));
      window.location.href = '/';
    }
  }

  return response;
}
